/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { approveOffer } from '../fn/offers/approve-offer';
import { ApproveOffer$Params } from '../fn/offers/approve-offer';
import { createOfferRequest } from '../fn/offers/create-offer-request';
import { CreateOfferRequest$Params } from '../fn/offers/create-offer-request';
import { getOfferCalculationStatusByOfferRequestId } from '../fn/offers/get-offer-calculation-status-by-offer-request-id';
import { GetOfferCalculationStatusByOfferRequestId$Params } from '../fn/offers/get-offer-calculation-status-by-offer-request-id';
import { getOfferDetailsByOfferRequestIdAndOfferId } from '../fn/offers/get-offer-details-by-offer-request-id-and-offer-id';
import { GetOfferDetailsByOfferRequestIdAndOfferId$Params } from '../fn/offers/get-offer-details-by-offer-request-id-and-offer-id';
import { getOfferDetailsByOfferRequestIdAndOfferIdAsExcel } from '../fn/offers/get-offer-details-by-offer-request-id-and-offer-id-as-excel';
import { GetOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Params } from '../fn/offers/get-offer-details-by-offer-request-id-and-offer-id-as-excel';
import { getOfferRequestById } from '../fn/offers/get-offer-request-by-id';
import { GetOfferRequestById$Params } from '../fn/offers/get-offer-request-by-id';
import { getOffersByOfferRequestId } from '../fn/offers/get-offers-by-offer-request-id';
import { GetOffersByOfferRequestId$Params } from '../fn/offers/get-offers-by-offer-request-id';
import { OfferApprovalResponse } from '../models/offer-approval-response';
import { OfferCalculationStatusResponse } from '../models/offer-calculation-status-response';
import { OfferDetailedResponse } from '../models/offer-detailed-response';
import { OfferRequestCreateResponse } from '../models/offer-request-create-response';
import { OfferRequestOffersResponse } from '../models/offer-request-offers-response';
import { updateOffer } from '../fn/offers/update-offer';
import { UpdateOffer$Params } from '../fn/offers/update-offer';


/**
 * Offer request and offer management endpoints. POST /requests requires PRODUCT_ADMIN and an active site context. All other endpoints require authentication only (no specific role restriction beyond isAuthenticated).
 */
@Injectable({ providedIn: 'root' })
export class OffersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOfferDetailsByOfferRequestIdAndOfferId()` */
  static readonly GetOfferDetailsByOfferRequestIdAndOfferIdPath = '/offers/requests/{offerRequestId}/offers/{offerId}';

  /**
   * Get offer details.
   *
   * Returns detailed information for the specified offer within the given offer request. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferDetailsByOfferRequestIdAndOfferId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferDetailsByOfferRequestIdAndOfferId$Response(params: GetOfferDetailsByOfferRequestIdAndOfferId$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferDetailedResponse>> {
    const obs = getOfferDetailsByOfferRequestIdAndOfferId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get offer details.
   *
   * Returns detailed information for the specified offer within the given offer request. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferDetailsByOfferRequestIdAndOfferId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferDetailsByOfferRequestIdAndOfferId(params: GetOfferDetailsByOfferRequestIdAndOfferId$Params, context?: HttpContext): Observable<OfferDetailedResponse> {
    const resp = this.getOfferDetailsByOfferRequestIdAndOfferId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfferDetailedResponse>): OfferDetailedResponse => r.body)
    );
  }

  /** Path part for operation `updateOffer()` */
  static readonly UpdateOfferPath = '/offers/requests/{offerRequestId}/offers/{offerId}';

  /**
   * Updates quantities in an offer.
   *
   * Changes item quantities in the specified offer. Changing a quantity can trigger recalculation of quantity discounts and basket discounts. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOffer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOffer$Response(params: UpdateOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferDetailedResponse>> {
    const obs = updateOffer(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates quantities in an offer.
   *
   * Changes item quantities in the specified offer. Changing a quantity can trigger recalculation of quantity discounts and basket discounts. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOffer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOffer(params: UpdateOffer$Params, context?: HttpContext): Observable<OfferDetailedResponse> {
    const resp = this.updateOffer$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfferDetailedResponse>): OfferDetailedResponse => r.body)
    );
  }

  /** Path part for operation `createOfferRequest()` */
  static readonly CreateOfferRequestPath = '/offers/requests';

  /**
   * Creates a new offer request.
   *
   * Creates an offer request containing the given parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOfferRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOfferRequest$Response(params?: CreateOfferRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferRequestCreateResponse>> {
    const obs = createOfferRequest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new offer request.
   *
   * Creates an offer request containing the given parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOfferRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOfferRequest(params?: CreateOfferRequest$Params, context?: HttpContext): Observable<OfferRequestCreateResponse> {
    const resp = this.createOfferRequest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfferRequestCreateResponse>): OfferRequestCreateResponse => r.body)
    );
  }

  /** Path part for operation `approveOffer()` */
  static readonly ApproveOfferPath = '/offers/requests/{offerRequestId}/offers/{offerId}/approve';

  /**
   * Approve an offer.
   *
   * Approves the specified offer, converting it into a purchase order. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveOffer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveOffer$Response(params: ApproveOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferApprovalResponse>>> {
    const obs = approveOffer(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Approve an offer.
   *
   * Approves the specified offer, converting it into a purchase order. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `approveOffer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveOffer(params: ApproveOffer$Params, context?: HttpContext): Observable<Array<OfferApprovalResponse>> {
    const resp = this.approveOffer$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OfferApprovalResponse>>): Array<OfferApprovalResponse> => r.body)
    );
  }

  /** Path part for operation `getOfferRequestById()` */
  static readonly GetOfferRequestByIdPath = '/offers/requests/{offerRequestId}';

  /**
   * Get a specific offer request.
   *
   * Get a specific offer request with the given UUID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferRequestById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferRequestById$Response(params: GetOfferRequestById$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferRequestCreateResponse>> {
    const obs = getOfferRequestById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a specific offer request.
   *
   * Get a specific offer request with the given UUID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferRequestById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferRequestById(params: GetOfferRequestById$Params, context?: HttpContext): Observable<OfferRequestCreateResponse> {
    const resp = this.getOfferRequestById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfferRequestCreateResponse>): OfferRequestCreateResponse => r.body)
    );
  }

  /** Path part for operation `getOfferCalculationStatusByOfferRequestId()` */
  static readonly GetOfferCalculationStatusByOfferRequestIdPath = '/offers/requests/{offerRequestId}/status';

  /**
   * Get status from a specified offer request.
   *
   * Get calculation status from a specified offer request with the given UUID. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferCalculationStatusByOfferRequestId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferCalculationStatusByOfferRequestId$Response(params: GetOfferCalculationStatusByOfferRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferCalculationStatusResponse>> {
    const obs = getOfferCalculationStatusByOfferRequestId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get status from a specified offer request.
   *
   * Get calculation status from a specified offer request with the given UUID. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferCalculationStatusByOfferRequestId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferCalculationStatusByOfferRequestId(params: GetOfferCalculationStatusByOfferRequestId$Params, context?: HttpContext): Observable<OfferCalculationStatusResponse> {
    const resp = this.getOfferCalculationStatusByOfferRequestId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfferCalculationStatusResponse>): OfferCalculationStatusResponse => r.body)
    );
  }

  /** Path part for operation `getOffersByOfferRequestId()` */
  static readonly GetOffersByOfferRequestIdPath = '/offers/requests/{offerRequestId}/offers';

  /**
   * Get all offers from a specified offer request.
   *
   * Returns all offers generated for the specified offer request. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffersByOfferRequestId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffersByOfferRequestId$Response(params: GetOffersByOfferRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferRequestOffersResponse>> {
    const obs = getOffersByOfferRequestId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all offers from a specified offer request.
   *
   * Returns all offers generated for the specified offer request. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOffersByOfferRequestId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffersByOfferRequestId(params: GetOffersByOfferRequestId$Params, context?: HttpContext): Observable<OfferRequestOffersResponse> {
    const resp = this.getOffersByOfferRequestId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OfferRequestOffersResponse>): OfferRequestOffersResponse => r.body)
    );
  }

  /** Path part for operation `getOfferDetailsByOfferRequestIdAndOfferIdAsExcel()` */
  static readonly GetOfferDetailsByOfferRequestIdAndOfferIdAsExcelPath = '/offers/requests/{offerRequestId}/offers/{offerId}/excel';

  /**
   * Download offer as Excel.
   *
   * Downloads the specified offer as an Excel (.xlsx) file. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferDetailsByOfferRequestIdAndOfferIdAsExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Response(params: GetOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = getOfferDetailsByOfferRequestIdAndOfferIdAsExcel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Download offer as Excel.
   *
   * Downloads the specified offer as an Excel (.xlsx) file. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferDetailsByOfferRequestIdAndOfferIdAsExcel(params: GetOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Params, context?: HttpContext): Observable<string> {
    const resp = this.getOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
